import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { ReactComponent as SortArrow } from '@styles/icons/sortArrowDesc.svg';
import React from 'react';

export const SortArrowDescIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} component={SortArrow} viewBox={'0 0 10 12'} />
);

export default SortArrowDescIcon;
